import React from "react";
import { useDrag } from "react-dnd";
import styled from "styled-components";

const PieceImage = styled.img`
  width: 100px;
  height: 100px;
  margin: 5px;
  object-fit: cover;
  border-radius: 12px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  cursor: grab;
  transition: transform 0.2s, opacity 0.2s, filter 0.2s, box-shadow 0.2s;

  /* Dragging state */
  opacity: ${({ isDragging }) => (isDragging ? 0.6 : 1)};
  transform: ${({ isDragging }) => (isDragging ? "scale(1.05)" : "scale(1)")};
  filter: ${({ isDragging }) =>
    isDragging ? "drop-shadow(0 8px 8px rgba(0,0,0,0.4))" : "none"};
  box-shadow: ${({ isDragging }) =>
    isDragging ? "0 8px 16px rgba(0, 0, 0, 0.5)" : "0 4px 8px rgba(0, 0, 0, 0.3)"};

  &:hover {
    transform: ${({ isDragging }) =>
      isDragging ? "scale(1.05)" : "scale(1.02)"};
    border-color: rgba(255, 255, 255, 0.6);
  }

  /* 📱 Responsive sizing – match your target grid breakpoints */
  @media (max-width: 600px) {
    width: 80px;
    height: 80px;
  }
  @media (max-width: 400px) {
    width: 62px;
    height: 62px;
  }
`;

const PuzzlePiece = ({ piece }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "PIECE",
    item: { id: piece.id, piece },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }), [piece]);

  return (
    <PieceImage
      ref={drag}
      src={piece.src}
      alt="puzzle piece"
      isDragging={isDragging}
    />
  );
};

export default PuzzlePiece;